module.exports = __webpack_public_path__ + "static/img/project5.277ae06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project5.jpg
// module id = a+js
// module chunks = 1